/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../apis/axiosConfig';
import { toast } from 'react-toastify';
import { FaBuilding, FaSearch, FaClipboardList, FaArrowRight } from 'react-icons/fa';
import '../pages_premium.css';
import './PropertyRequests.css';
import { getFullImageUrl } from '../utils/url';
import AdminPagination from '../components/common/AdminPagination';

export default function PropertyRequestsList() {
    const [properties, setProperties] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const navigate = useNavigate();

    useEffect(() => {
        setCurrentPage(1);
    }, [search]);

    const fetchPropertyRequests = async () => {
        try {
            setLoading(true);
            const res = await axiosInstance.get('/admin/property-requests');
            setProperties(res.data || []);
        } catch (error) {
            console.error('Error fetching property requests:', error);
            toast.error('Failed to load property requests');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPropertyRequests();
    }, []);

    const formatDate = (val) => {
        if (!val) return '-';
        const dateObj = new Date(val);
        if (!isNaN(dateObj.getTime())) {
            const day = String(dateObj.getDate()).padStart(2, '0');
            const month = String(dateObj.getMonth() + 1).padStart(2, '0');
            const year = dateObj.getFullYear();
            return `${day}/${month}/${year}`;
        }
        return String(val);
    };

    const getRoleBadgeClass = (role) => {
        const r = String(role || '').toLowerCase();
        if (r === 'student') return 'role-badge role-badge-student';
        if (r === 'lister' || r === 'agent') return 'role-badge role-badge-lister';
        if (r === 'business owner' || r === 'owner') return 'role-badge role-badge-owner';
        return 'role-badge role-badge-default';
    };

    const filtered = properties.filter(p =>
        p.title?.toLowerCase().includes(search.toLowerCase()) ||
        p.listed_by?.toLowerCase().includes(search.toLowerCase()) ||
        p.email?.toLowerCase().includes(search.toLowerCase()) ||
        p.address?.toLowerCase().includes(search.toLowerCase())
    );

    const paginatedProperties = filtered.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    return (
        <div className="page-premium-wrapper properties-list-page">
            <div className="page-premium-content">

                {/* Hero Header */}
                <div className="page-hero-header page-hero-properties">
                    <div className="ph-blob ph-blob-1"></div>
                    <div className="ph-blob ph-blob-2"></div>

                    <div className="ph-left">
                        <div className="ph-icon" style={{ background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)' }}>
                            <FaClipboardList size={26} />
                        </div>
                        <div>
                            <h1 className="ph-title">Property Requests</h1>
                            <p className="ph-subtitle">Overview of all properties receiving tenant requests and enquiries</p>
                        </div>
                    </div>

                    <div className="ph-right">
                        <div className="ph-count-badge">
                            <span className="count-num">{properties.length}</span>
                            <span className="count-lbl">Properties with Requests</span>
                        </div>
                    </div>
                </div>

                {/* Table Card */}
                <div className="premium-table-card">
                    <div className="ptable-toolbar">
                        <div className="ptable-title">
                            <span className="ptable-title-dot"></span>
                            Property Requests Summary
                        </div>
                        <div className="ptable-search">
                            <FaSearch className="ptable-search-icon" />
                            <input
                                type="text"
                                placeholder="Search by property, lister, or email..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="ptable-wrap">
                        <table className="premium-table">
                            <thead>
                                <tr>
                                    <th style={{ width: '50px' }}>#</th>
                                    <th style={{ minWidth: '240px' }}>Property</th>
                                    <th style={{ whiteSpace: 'nowrap' }}>Listed By</th>
                                    <th>Listed Type</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Listed Date</th>
                                    <th style={{ textAlign: 'center' }}>Total Requests</th>
                                    <th style={{ textAlign: 'center' }}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="9" style={{ textAlign: 'center', padding: '40px 0' }}>
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                            <p className="mt-2 text-muted" style={{ fontSize: '0.85rem' }}>Loading property requests...</p>
                                        </td>
                                    </tr>
                                ) : filtered.length === 0 ? (
                                    <tr>
                                        <td colSpan="9">
                                            <div className="ptable-empty">
                                                <div className="ptable-empty-icon">📋</div>
                                                <p>No properties with requests found.</p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    paginatedProperties.map((property, idx) => (
                                        <tr key={property.id}>
                                            <td style={{ color: '#9ba6c0', fontWeight: 600 }}>#{(currentPage - 1) * pageSize + idx + 1}</td>
                                            <td style={{ minWidth: '240px' }}>
                                                <div className="prop-title-cell">
                                                    {property.images && property.images.length > 0 ? (
                                                        <img
                                                            src={getFullImageUrl(property.images[0].image_url)}
                                                            alt="Property Thumbnail"
                                                            className="prop-thumb"
                                                        />
                                                    ) : (
                                                        <div className="prop-thumb-fallback">
                                                            <FaBuilding size={14} />
                                                        </div>
                                                    )}
                                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <strong className="prop-title-text">{property.title || 'Untitled'}</strong>
                                                        <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>{property.address || 'Address not specified'}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ whiteSpace: 'nowrap' }}>
                                                <span style={{ fontWeight: 600, color: '#1e293b', whiteSpace: 'nowrap' }}>{property.listed_by || 'Unknown'}</span>
                                            </td>
                                            <td>
                                                <span className={getRoleBadgeClass(property.listed_type)}>
                                                    {property.listed_type || 'Lister'}
                                                </span>
                                            </td>
                                            <td>{property.email || '-'}</td>
                                            <td>{property.phone || '-'}</td>
                                            <td>{formatDate(property.listed_date)}</td>
                                            <td style={{ textAlign: 'center' }}>
                                                <span className="req-count-badge">
                                                    {property.total_requests} {property.total_requests === 1 ? 'Request' : 'Requests'}
                                                </span>
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <button
                                                    type="button"
                                                    className="btn-view-requests"
                                                    onClick={() => navigate(`/property-requests/${property.id}`)}
                                                >
                                                    View All Requests <FaArrowRight size={11} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                    <AdminPagination
                        currentPage={currentPage}
                        totalItems={filtered.length}
                        pageSize={pageSize}
                        onPageChange={setCurrentPage}
                        onPageSizeChange={setPageSize}
                        itemLabel="properties"
                    />
                </div>

            </div>
        </div>
    );
}
